import { ModalLikeContainer } from "../modal/modal-style";
import { styled } from "sharedUI/styles";

export const ModalContainer = styled(ModalLikeContainer)`
    width: 400px;
    border-radius: 12px;
    padding: 24px 32px;

    > .header {
        display: flex;
        align-items: left;
        font-size: 18px;
        line-height: 32px;
        min-height: 32px;
        color: ${p => p.theme.fgColorDark};

        em {
            font-weight: bold;
            font-style: normal;
        }
    }

    > .content {
        height: 100%;
        font-size: 12px;
        padding-bottom: 26px;

        > .info {
            color: ${p => p.theme.fgColorDark};
            padding: 0px 0px 0px 30px;
            margin-bottom: 8px;
        }
    }

    > .privacy-settings-footer {
        display: flex;
        justify-content: flex-end;
        > :first-child {
            margin-right: 8px;
        }
    }
`;
